import { collection, onSnapshot, doc, getDocs, addDoc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "@/fb.js";
import { config } from "@/utils/configuration/config";
import { getErrorMessageFromFirebaseError } from "@/utils/utils";

export default class ShipRepoFirebase {
  getShips(ships, service) {
    //sconsole.log("ShipRepoFirebase-getShips from", config.firebaseConfig.shipsCollectionName);
    onSnapshot(collection(db, config.firebaseConfig.shipsCollectionName), (querySnapshot) => {
      const changes = querySnapshot.docChanges();

      changes.forEach((change) => {
        //console.log("ShipRepoFirebase-getShips. Change = ", change);
        if (change.type === "added") {
          service.addNewShipFromRepo(ships, change.doc.id, change.doc.data());
        } else if (change.type === "modified") {
          service.modifyShipFromRepo(ships, change.doc.id, change.doc.data());
        } else if (change.type === "removed") {
          service.removeShipFromRepo(ships, change.doc.id);
        }
      });
    });
  }

  editShip(shipId, ship) {
    //console.log("ShipRepoFirebase-editShip", shipId, ship);

    const shipRef = doc(db, config.firebaseConfig.shipsCollectionName, shipId);

    var errors = "";
    try {
      setDoc(shipRef, ship);
    } catch (error) {
      //console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    //console.log("ShipRepoFirebase-editShip fin");
    return errors;
  }

  saveNewShip(ship) {
    //console.log("ShipRepoFirebase-saveNewShip", ship);

    var errors = "";
    try {
      addDoc(collection(db, config.firebaseConfig.shipsCollectionName), ship);
    } catch (error) {
      //console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    return errors;
  }

  async deleteShip(shipId) {
    //console.log("Holaaaaaaaaaaaaa " + shipId)
    const shipRef = doc(db, config.firebaseConfig.shipsCollectionName, shipId);
    //console.log(config.firebaseConfig.shipModificationsName);
    const shipModRef = collection(shipRef, config.firebaseConfig.shipModificationsName);
    //console.log("Intento coger la referencia a las modificaciones");
    const shipMods = await getDocs(shipModRef);
    //console.log(shipMods);
    shipMods.docs.forEach(async (document) => {
      try{
        //console.log("Intento coger las modificaciones");
        const docRef = doc(shipRef, config.firebaseConfig.shipModificationsName, document.id);
        await deleteDoc(docRef);
      } catch (error) {
        //console.error('Error al intentar eliminar el documento:', error);
      }
    })

    //console.log("Ya he cogido las modificaciones")

    await deleteDoc(shipRef);
  }
}
